import React from 'react';
import { motion } from 'framer-motion';
import { WhatsAppButton } from './WhatsAppButton';
import { Users } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[80vh] flex flex-col items-center justify-center px-4 pt-16 pb-16 overflow-hidden bg-dark" data-id="element-36">
      <div className="max-w-4xl mx-auto text-center z-10" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center gap-2 bg-whatsapp/10 border border-whatsapp/20 rounded-full px-4 py-2 mb-8" data-id="element-38">
          <span className="relative flex h-3 w-3" data-id="element-39">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-whatsapp opacity-75" data-id="element-40"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-whatsapp" data-id="element-41"></span>
          </span>
          <span className="text-sm font-bold text-whatsapp" data-id="element-42">
            🔥 Cupos limitados
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-display text-4xl md:text-6xl lg:text-7xl font-extrabold leading-tight mb-6 text-white" data-id="element-43">
          Aprendé <span className="text-whatsapp" data-id="element-44">GRATIS</span> cómo empezar a
          vender <span className="text-whatsapp" data-id="element-45">Ebooks</span> digitales
        </motion.h1>

        <motion.div initial={{
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-24 h-1.5 bg-whatsapp rounded-full mx-auto mb-8" data-id="element-46" />

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-gray-400 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-47">
          Unite a mi comunidad de WhatsApp para ver los horarios y acceder a una
          charla en vivo donde te explico paso a paso cómo generar tus primeras
          ventas.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex flex-col items-center gap-4" data-id="element-48">
          <WhatsAppButton className="w-full md:w-auto" data-id="element-49">
            UNIRME AL WHATSAPP GRATIS
          </WhatsAppButton>

          <div className="flex items-center gap-2 text-sm text-gray-500 mt-2 font-medium" data-id="element-50">
            <Users className="w-4 h-4" data-id="element-51" />
            <p data-id="element-52">Entrá al grupo para ver horarios y asegurar tu lugar</p>
          </div>
        </motion.div>
      </div>
    </section>;
}